import { add } from "date-fns";
import { datatype, lorem, random } from "faker/locale/en_US";

import {
  defaultDealCategories,
  defaultDealStages,
} from "../../../root/defaultConfiguration";
import type { Deal } from "../../../types";
import type { Db } from "./types";
import { randomDate } from "./utils";

const testDeals = [
  {
    name: "BPO Financeiro e Gestão de Fluxo de Caixa",
    amount: 450000,
    stage: "prospeccao",
    category: "bpo-financeiro",
    description:
      "Proposta de terceirização do departamento financeiro e contas a pagar/receber.",
  },
  {
    name: "Migração Contábil e Abertura de Filial",
    amount: 320000,
    stage: "qualificacao",
    category: "contabilidade-mensal",
    description:
      "Serviço contábil mensal com suporte à constituição de nova filial comercial.",
  },
  {
    name: "Planejamento e Recuperação Tributária",
    amount: 1500000,
    stage: "proposta",
    category: "recuperacao-tributaria",
    description:
      "Diagnóstico fiscal e recuperação de créditos de PIS/COFINS dos últimos 5 anos.",
  },
];

export const generateDeals = (db: Db, size = 3): Deal[] => {
  const deals = Array.from(Array(size).keys()).map((id) => {
    const predefined = testDeals[id % testDeals.length];
    const company = db.companies[id % db.companies.length] || db.companies[0];
    company.nb_deals = (company.nb_deals ?? 0) + 1;
    const companyContacts = db.contacts.filter(
      (contact) => contact.company_id === company.id,
    );
    const contacts = companyContacts.length > 0 ? [companyContacts[0]] : [];
    const created_at = randomDate(new Date(company.created_at)).toISOString();

    const expected_closing_date = randomDate(
      new Date(created_at),
      add(new Date(created_at), { months: 3 }),
    )
      .toISOString()
      .split("T")[0];

    return {
      id,
      name: predefined?.name || `Negócio de Teste #${id + 1}`,
      company_id: company.id,
      contact_ids: contacts.map((contact) => contact.id),
      category:
        predefined?.category ||
        random.arrayElement(defaultDealCategories).value,
      stage: predefined?.stage || random.arrayElement(defaultDealStages).value,
      description: predefined?.description || lorem.paragraphs(2),
      amount: predefined?.amount ?? datatype.number(1000) * 100,
      created_at,
      updated_at: randomDate(new Date(created_at)).toISOString(),
      expected_closing_date,
      sales_id: company.sales_id ?? 0,
      index: 0,
      status: "aberto" as const,
    };
  });
  // compute index based on stage
  defaultDealStages.forEach((stage) => {
    deals
      .filter((deal) => deal.stage === stage.value)
      .forEach((deal, index) => {
        deals[deal.id].index = index;
      });
  });
  return deals;
};
